import React, { useEffect, useRef, useState } from "react";
import { Button, Divider, Popover, Spin, Modal, Cascader } from "antd";
import toast from "react-hot-toast";
import { useTextSelection } from "ahooks";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import MathJax from "react-mathjax-preview";
import ContentEditable from "react-contenteditable";
import counterService from "@services/counter.service";
import groupBy from "lodash/groupBy";
import Treeview from "../Queries/components/TreeView";
import kpiService from "@services/kpi.service";
import { fetchKpiAsync } from "src/features/kpi/kpiSlice";
// import KpiTreeEditor from "@components/KpiTree/KpiTreeEditor";

const { confirm } = Modal;

function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

function childrenOf(data, parent) {
  return (data[parent] || []).map((kpi) => ({
    id: kpi._id,
    key: kpi._id,
    parent: parent,
    title: kpi.name,
    name: kpi.name,
    description: kpi.description,
    vendor: kpi.vendor,
    createBy: kpi.createBy,
    formula: kpi.formula,
    release: kpi.release,
    unit: kpi.unit,
    Category: kpi.Category,
    counters: kpi.counters,
    formula_id: kpi.formula_id,
    children: childrenOf(data, kpi._id),
  }));
}

function groupByUnitDesc(data) {
  let grouped = groupBy([...data], (counter) => counter.unit_description);

  grouped = Object.entries(grouped).map(([key, value]) => {
    return {
      label: key,
      value: key,
      title: key,
      children: value.reduce((result, child) => {
        result.push({
          ...child,
          label: `${child.name} (${child.c_id})`,
          value: `"${child.name}"`,
          title: `${child.name} (${child.c_id})`,
        });
        return result;
      }, []),
    };
  });

  return [...grouped];
}

function groupBySetDesc(data) {
  let grouped = groupBy([...data], (counter) => counter.set_description);

  grouped = Object.entries(grouped).map(([key, value]) => {
    return {
      label: key,
      value: key,
      title: key,
      children: groupByUnitDesc(value),
      // ...value,
    };
  });

  return [...grouped];
}

function groupByTypeDesc(data) {
  let grouped = groupBy([...data], (counter) => counter.type_description);

  grouped = Object.entries(grouped).map(([key, value]) => {
    return {
      label: key,
      value: key,
      title: key,
      children: groupBySetDesc(value, "set_description"),
      // ...value,
    };
  });

  return grouped;
}

function showConfirm({ clearAll }) {
  confirm({
    title: "Do you Want to delete these items?",
    content: "",
    onOk() {
      clearAll();
      // inpRef.current.innerText = "";
      // triggerInput(inpRef);
    },
    onCancel() {
      console.log("Cancel");
    },
  });
}

const showConfirmFormula = ({ formula, submitFormula, dispatch }) => {
  confirm({
    title: "Are you Want to save these item?",
    icon: <ExclamationCircleOutlined />,
    content: (
      <>
        {/* <div className="mt-12">
         <MathJax math={`\`${formula}\``} />
       </div> */}
      </>
    ),
    onOk() {
      return new Promise((resolve, reject) => {
        submitFormula()
          .then((res) => {
            toast.success("Kpi Updated");
            dispatch(fetchKpiAsync());
            resolve(true);
          })
          .catch((err) => {
            toast.error("Update Kpi has error");
            console.log(err);
            reject(err);
          });
      });
    },
    onCancel() {
      console.log("Cancel");
    },
  });
};

const Generator = () => {
  const inpRef = useRef(null);
  const {
    text = "",
    left = 0,
    top = 0,
    height = 0,
    width = 0,
  } = useTextSelection(inpRef);
  const [counters, setCounters] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [selectedFormula, setSelectedFormula] = useState(null);

  const [formula, setFormula] = useState([]);
  const [formulaId, setFormulaId] = useState([]);
  const [counterIds, setCounterIds] = useState([]);

  const [visible, setVisible] = useState(false);
  // eslint-disable-next-line
  const [editable, setEditable] = useState(false);
  // eslint-disable-next-line
  const [info, setInfo] = useState("");

  const dispatch = useDispatch();
  const { loading, data: kpisDataset } = useSelector((state) => state.kpis);

  function filter(inputValue, path) {
    return path.some(
      (option) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  }

  async function fetcherCounters() {
    try {
      const res = await counterService.fetchCounter();
      setCounters(groupByTypeDesc(res.data));
    } catch (err) {
      console.log(err);
    }
  }

  function fetcherKpis() {
    dispatch(fetchKpiAsync());
  }

  useEffect(() => {
    fetcherCounters();
    fetcherKpis();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setKpis(
      childrenOf(
        groupBy(kpisDataset, (kpi) => kpi.parent),
        "0"
      )
    );
  }, [kpisDataset]);

  useEffect(() => {
    console.log("formula", formula);
  }, [formula]);

  function onChange(value, selectedOptions) {
    if (selectedOptions) {
      const s = selectedOptions[selectedOptions.length - 1];
      if (s) {
        let counter = s.c_id;
        counter = counter.replace(/c_/g, "");

        setFormula([...formula, s.value]);
        setFormulaId([...formulaId, `sum("${counter}")`]);
        setCounterIds([...counterIds, counter]);
      }
    }
  }

  function addOp(op) {
    setFormula([...formula, op]);
    setFormulaId([...formulaId, op]);
  }

  function addCrodHoundred() {
    setFormula([...formula, "**", "100"]);
    setFormulaId([...formulaId, "**", "100"]);
  }

  function deleteLastItem() {
    setFormula([...formula.slice(0, formula.length - 1)]);
    setFormulaId([...formulaId.slice(0, formulaId.length - 1)]);
    setCounterIds([...counterIds.slice(0, counterIds.length - 1)]);
  }

  function submitFormula() {
    return kpiService.createKpi({
      ...selectedFormula,
      name: selectedFormula.name,
      title: selectedFormula.name,
      formula: formula.join(""),
      formula_id: `${formulaId
        // eslint-disable-next-line
        .map((x) => x.replace(/\*\*/, "*").replace(/\"/g, "`"))
        .join("")}`,
      counters: Array.from(new Set(counterIds)),
    });
  }

  useEffect(() => {
    if (text.trim() === "") {
      setVisible(false);
      return;
    }
    // setLoading(true);
    // setVisible(true);
    // fetchData(text);
  }, [text]);

  useEffect(() => {
    if (
      selectedFormula &&
      selectedFormula.hasOwnProperty("formula") &&
      selectedFormula.formula
    ) {
      setFormula([
        ...(selectedFormula.formula || "")
          .replace('^"(.*)', "$1")
          .replace('(.*)"$', "$1")
          // .substr(0, selectedFormula.formula.length - 1)
          .split('"')
          .reduce((result, item) => {
            if (!item.match(/(\+|\/|\(|\)|-|\*\*)/) && !isBlank(item)) {
              result.push(`"${item}"`);
            } else if (!isBlank(item)) {
              result.push(item);
            }
            return result;
          }, []),
      ]);

      setCounterIds(selectedFormula.counters || []);
    } else {
      setFormula([]);
      setCounterIds([]);
    }

    if (
      selectedFormula &&
      selectedFormula.hasOwnProperty("formula_id") &&
      selectedFormula.formula_id
    ) {
      const ids = selectedFormula.formula_id
        // eslint-disable-next-line
        .split(/(sum\(`\d*`\))|(\*)|(-)|(\+)|(\/)|(\()|(\))/g)
        .filter((x) => x !== undefined && x.length);
      setFormulaId(ids || []);
    } else {
      setFormulaId([]);
    }
  }, [selectedFormula]);

  return (
    <>
      <div className="p-5 flex-grow flex flex-col">
        <div className="space-x-3 flex-grow flex items-stretch">
          <div className="flex-grow flex flex-col h-full-tree">
            <div className="h-full flex flex-col bg-white rounded border border-gray-200 p-2">
              <Treeview
                multiple={false}
                filter
                loading={loading === "loading"}
                customizable
                dataSource={kpis}
                name="kpi"
                handleSelect={(selectedKeys, e) => {
                  if (e) setSelectedFormula(e);
                  else setSelectedFormula(null);
                }}
                handleChange={() => {}}
                forceUpdateDataset={() => {
                  fetcherKpis();
                }}
              />
            </div>
          </div>
          <div className="flex-grow flex-shrink-0 flex flex-col h-full-tree">
            <div className="flex-grow flex flex-col bg-white rounded border border-gray-200">
              <div className="flex flex-col bg-white rounded h-96 overflow-hidden flex-grow">
                <div className="flex divide-x divide-gray-300 border-b">
                  <Cascader
                    bordered={false}
                    style={{ width: 450 }}
                    options={counters}
                    onChange={onChange}
                    placeholder="Please select"
                    showSearch={{ filter }}
                  />

                  <ButtonOperator
                    disable={editable}
                    text="*"
                    value="**"
                    elm={inpRef}
                    add={addOp}
                  />
                  <ButtonOperator
                    disable={editable}
                    text="+"
                    value="+"
                    elm={inpRef}
                    add={addOp}
                  />
                  <ButtonOperator
                    disable={editable}
                    text="-"
                    value="-"
                    elm={inpRef}
                    add={addOp}
                  />
                  <ButtonOperator
                    disable={editable}
                    text="/"
                    value="/"
                    elm={inpRef}
                    add={addOp}
                  />
                  <ButtonOperator
                    disable={editable}
                    text="("
                    value="("
                    elm={inpRef}
                    add={addOp}
                  />
                  <ButtonOperator
                    disable={editable}
                    text=")"
                    value=")"
                    elm={inpRef}
                    add={addOp}
                  />
                  {/* <button
                    type="button"
                    className="flex-grow p-2 flex justify-center items-center"
                    onClick={() => setEditable(!editable)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                      <path
                        fillRule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button> */}
                  <button
                    type="button"
                    className="flex-grow p-2 flex justify-center items-center"
                    onClick={() => addCrodHoundred()}
                  >
                    * 100
                  </button>

                  <button
                    type="button"
                    className="flex-grow p-2 flex justify-center items-center"
                    onClick={() =>
                      showConfirm({
                        clearAll: () => {
                          setCounterIds([]);
                          setFormula([]);
                          setFormulaId([]);
                        },
                      })
                    }
                  >
                    C
                  </button>

                  <button
                    type="button"
                    className="flex-grow p-2 flex justify-center items-center"
                    onClick={deleteLastItem}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6.707 4.879A3 3 0 018.828 4H15a3 3 0 013 3v6a3 3 0 01-3 3H8.828a3 3 0 01-2.12-.879l-4.415-4.414a1 1 0 010-1.414l4.414-4.414zm4 2.414a1 1 0 00-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 101.414 1.414L12 11.414l1.293 1.293a1 1 0 001.414-1.414L13.414 10l1.293-1.293a1 1 0 00-1.414-1.414L12 8.586l-1.293-1.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <ContentEditable
                  innerRef={inpRef}
                  html={[...formula].join("")} // innerHTML of the editable div
                  disabled={!editable} // use true to disable editing
                  // onChange={(e) => setFormula(e.target.value)} // handle innerHTML change
                  tagName="article" // Use a custom HTML tag (uses a div by default)
                  className="flex-grow bg-gray-50 p-3 overflow-hidden overflow-y-auto break-words focus:outline-none"
                />
                <div className="bg-gray-50">
                  <Divider orientation="left">Result</Divider>
                </div>
                <div className="px-6 pb-5 bg-gray-50">
                  <MathJax math={`\`${[...formula].join("")}\``} />
                </div>
                <Button
                  type="primary"
                  htmlType="button"
                  className="rounded-none border border-primary-300 font-medium py-1.5"
                  size="large"
                  block
                  onClick={() =>
                    showConfirmFormula({ formula, submitFormula, dispatch })
                  }
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popover
        content={
          <Spin spinning={loading}>{loading ? "Fetch Data..." : info}</Spin>
        }
        visible={visible}
      >
        <span
          style={{
            position: "fixed",
            top: `${top}px`,
            left: `${left}px`,
            height: `${height}px`,
            width: `${width}px`,
            pointerEvents: "none",
          }}
        />
      </Popover>
    </>
  );
};

export default Generator;

const ButtonOperator = ({ disable, text, value, elm, add }) => {
  function handleClick() {
    // if (!disable) handleConcatText(value, elm, true);
    if (!disable) add(value);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex-grow p-2 text-center ${
        disable ? "bg-gray-50 opacity-60 cursor-not-allowed" : ""
      }`}
    >
      {text}
    </button>
  );
};
